import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import SubmitButtonInfo from '@/app/editor/sidebar/elementsInfo/submitButton';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:muti',
    name: 'editText',
    targetSelectors: ['.gf_button'],
    property: '',
  },
  {
    type: 'css',
    name: 'font-size',
    targetSelector: '.gf_button',
    property: 'font-size',
    require: true,
  },
  {
    type: 'css',
    name: 'font',
    targetSelector: '.gf_button',
    property: 'font-family',
    require: true,
  },
  {
    type: 'css',
    name: 'button-color',
    targetSelector: '.gf_button',
    fieldType: 'color',
    property: 'background-color',
    require: true,
  },
  {
    type: 'css',
    name: 'text-color',
    targetSelector: '.gf_button',
    fieldType: 'color',
    property: 'color',
    require: true,
  },
  {
    type: 'css',
    name: 'button-color-hover',
    targetSelector: '.gf_button:hover',
    fieldType: 'color',
    property: 'background-color',
  },
  {
    type: 'css',
    name: 'text-color-hover',
    targetSelector: '.gf_button:hover',
    fieldType: 'color',
    property: 'color',
  },
  {
    type: 'custom:condition',
    name: 'buttonHover',
    targetSelector: '',
    links: 'button-color-hover,text-color-hover',
    condition: {
      // eslint-disable-next-line quotes
      syntax: `"#{button-color-hover}" != "undefined" || "#{text-color-hover}" != "undefined"`,
      success: 1,
      fail: 0,
    },
    property: '',
  },
  {
    type: 'html:stretch',
    name: 'stretch',
    targetSelector: '.elm',
    attrStoredSelector: '.elm',
    property: 'gf_button-stretch',
  },
  {
    type: 'css',
    name: 'width',
    targetSelector: '.gf_button',
    property: 'width',
  },
  {
    type: 'css',
    name: 'height',
    targetSelector: '.gf_button',
    property: 'height',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.elm',
    property: 'align',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
  },
];
/**
 * Button Atom Element
 */
export class GpSubmitButton extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : SubmitButtonInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || SubmitButtonInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || SubmitButtonInfo.slug;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + SubmitButtonInfo.class;
  }
}
